module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Entidades")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), (!_vm.entidade.notice) ? _c('div', {
    staticClass: "box-header with-border",
    attrs: {
      "ssm-lte-loading": "cmptSimpleRegisterEntityForm",
      "ng-hide": "$ctrl.entity.status === 'PENDENTE_APROVACAO'  ||  $ctrl.entity.status === 'COMPLETO' || $ctrl.entity.status =='INCOMPLETO'"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.processos.simplifiedNumber),
      expression: "processos.simplifiedNumber"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "id": "processo",
      "name": "processo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.processos, "simplifiedNumber", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.escolhido]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.processos), function(processo) {
    return _c('option', {
      domProps: {
        "value": processo
      }
    }, [_vm._v(_vm._s(processo.simplifiedNumber))])
  })], 2)])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "Entidade"
    }
  }, [(_vm.procSelecionado || ((_vm.entidade.notice) && (_vm.entidade.active === false))) ? _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope",
    attrs: {
      "ng-if": "show.grid"
    }
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "dadosCadastrais"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmCommonRegister",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "col-md-7 col-lg-6",
    attrs: {
      "id": "cadastroJuri"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Razão social')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.companyName),
      expression: "entidade.companyName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Razão social",
    staticClass: "form-control",
    attrs: {
      "name": "Razão social",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "companyName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('CNPJ')
    }
  }, [_c('label', {
    ref: "CNPJ",
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "CNPJ"
    }
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:14|max:14'),
      expression: "'required|min:14|max:14'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ",
      "type": "text",
      "mask": "NN.NNN.NNN/NNNN-##",
      "tokens": _vm.$cnpjTokens
    },
    model: {
      value: (_vm.entidade.cnpj),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "cnpj", $$v)
      },
      expression: "entidade.cnpj"
    }
  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo CNPJ é obrigatório')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cnpjExpeditionTime')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "cnpjExpeditionTime"
    }
  }, [_vm._v("Expedição CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "cnpjExpeditionTime",
    attrs: {
      "name": "cnpjExpeditionTime",
      "use-utc": true,
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "format": "dd/MM/yyyy",
      "placeholder": _vm.dataPlaceholder,
      "placeholder": "__ /__ /____"
    },
    model: {
      value: (_vm.entidade.cnpjExpeditionTime),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "cnpjExpeditionTime", $$v)
      },
      expression: "entidade.cnpjExpeditionTime"
    }
  }), _vm._v(" "), (_vm.errors.first('cnpjExpeditionTime')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Expedição do CNPJ é obrigatório')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Nome fantasia')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "Nome fantasia"
    }
  }, [_vm._v("Nome fantasia:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.businessName),
      expression: "entidade.businessName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Nome fantasia",
    staticClass: "form-control",
    attrs: {
      "name": "Nome fantasia",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.businessName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "businessName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Nome fantasia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Nome fantasia é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-7",
    class: {
      'has-error': _vm.errors.first('Telefone')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Telefone: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "name": "Telefone"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.entidade.contact.phone),
      callback: function($$v) {
        _vm.$set(_vm.entidade.contact, "phone", $$v)
      },
      expression: "entidade.contact.phone"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-7",
    class: {
      'has-error': _vm.errors.first('email')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "name": "email"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.email),
      expression: "entidade.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.entidade.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "email", $event.target.value)
      }, function($event) {
        _vm.entidade.email = $event.target.value.toLowerCase()
      }]
    }
  })]), _vm._v(" "), (_vm.errors.first('email')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('email')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(3), _vm._v(" "), _c('endereco', {
    attrs: {
      "entEnderecos": _vm.entidade.address
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(4), _vm._v(" "), _c('dirigentes', {
    attrs: {
      "entDirigentes": _vm.entidade.chiefs,
      "name": "dirigentes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos', {
    attrs: {
      "propDocumentos": _vm.entidade.documents,
      "documentTypes": _vm.docs,
      "documentosObrigatorios": _vm.docs
    }
  })], 1)])])])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "Proposta"
    }
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Projeto")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('nome da proposta')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "nome da proposta"
    }
  }, [_vm._v("Nome do Projeto:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.name),
      expression: "propostaSimplificada.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome da proposta",
      "id": "nome da proposta",
      "type": "text"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome da proposta')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome da proposta')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('investimento previsto')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "investimento previsto"
    }
  }, [_vm._v("Investimento Previsto:")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "investimento previsto",
      "approval": "propSimpleCtrl.approval",
      "state": "propSimpleCtrl.approvalState"
    }
  }, [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:20'),
      expression: "'required|max:20'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "investimento previsto",
      "id": "investimento previsto",
      "maxlength": "20",
      "type": "text"
    },
    model: {
      value: (_vm.propostaSimplificada.investment),
      callback: function($$v) {
        _vm.$set(_vm.propostaSimplificada, "investment", $$v)
      },
      expression: "propostaSimplificada.investment"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('investimento previsto')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('investimento previsto')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Agência condutora do projeto")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Agência")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required col-md-12",
    class: {
      'has-error': _vm.errors.first('agencia')
    },
    attrs: {
      "uib-tooltip": "Prefixo da Agência"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "agencia"
    }
  }, [_vm._v("Agência:")]), _vm._v(" "), _c('div', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "font-size": "4px"
    },
    attrs: {
      "options": _vm.agencias,
      "custom-label": _vm.numeroNomeAgencia,
      "placeholder": "Selecione uma agência",
      "label": "type",
      "track-by": "type",
      "preselect-first": false,
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "selectedLabel": "",
      "name": "agencia",
      "value": _vm.valor
    },
    on: {
      "search-change": _vm.buscaAgencias
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.buscaAgencia(_vm.agenciaSelecionada.code)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag"
        }, [_c('span', [_vm._v(_vm._s(props.option.type))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }]),
    model: {
      value: (_vm.agenciaSelecionada),
      callback: function($$v) {
        _vm.agenciaSelecionada = $$v
      },
      expression: "agenciaSelecionada"
    }
  }, [_vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('agencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('agencia')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('CNPJ agência')
    },
    attrs: {
      "uib-tooltip": "CNPJ da Agência"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "CNPJ agência"
    }
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255|cnpj'),
      expression: "'required|max:255|cnpj'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ agência",
      "id": "CNPJ agência",
      "mask": ['NN.NNN.NNN/NNNN-##'],
      "tokens": _vm.$cnpjTokens
    },
    model: {
      value: (_vm.propostaSimplificada.agencyCNPJ),
      callback: function($$v) {
        _vm.$set(_vm.propostaSimplificada, "agencyCNPJ", $$v)
      },
      expression: "propostaSimplificada.agencyCNPJ"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ agência')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('endereço da agência')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "endereço da agência"
    }
  }, [_vm._v("Endereço da agência:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.agencyAddress),
      expression: "propostaSimplificada.agencyAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "endereço da agência",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.agencyAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "agencyAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('endereço da agência')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('endereço da agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('telefone agência')
    },
    attrs: {
      "uib-tooltip": "Telefone da agência"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "telefone agência"
    }
  }, [_vm._v("Telefone da agência:")]), _vm._v(" "), _c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "telefone agência",
      "id": "telefone agência",
      "mask": ['(##) ####-####', '(##) #####-####'],
      "type": "text",
      "maxlength": "255"
    },
    model: {
      value: (_vm.propostaSimplificada.agencyPhone),
      callback: function($$v) {
        _vm.$set(_vm.propostaSimplificada, "agencyPhone", $$v)
      },
      expression: "propostaSimplificada.agencyPhone"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('telefone agência')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('telefone agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('email agência')
    },
    attrs: {
      "uib-tooltip": "E-mail da agência"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "email agência"
    }
  }, [_vm._v("E-mail da agência:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.agencyEmail),
      expression: "propostaSimplificada.agencyEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255|email'),
      expression: "'required|max:255|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email agência",
      "type": "email",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.agencyEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "agencyEmail", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('email agência')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('email agência')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Gerente")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('nome gerente')
    },
    attrs: {
      "uib-tooltip": "Nome do Gerente"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "nome gerente"
    }
  }, [_vm._v("Nome do Gerente:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.managerName),
      expression: "propostaSimplificada.managerName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome gerente",
      "id": "nome gerente",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.managerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "managerName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome gerente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('nacionalidade do gerente')
    },
    attrs: {
      "uib-tooltip": "Nacionalidade do Gerente"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "nacionalidade do gerente"
    }
  }, [_vm._v("Nacionalidade:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.managerNationality),
      expression: "propostaSimplificada.managerNationality"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nacionalidade do gerente",
      "id": "nacionalidade do gerente",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.managerNationality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "managerNationality", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nacionalidade do gerente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nacionalidade do gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('profissão do gerente')
    },
    attrs: {
      "uib-tooltip": "Profissão do Gerente"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "profissão do gerente"
    }
  }, [_vm._v("Profissão:")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.managerOccupation",
      "approval": "propSimpleCtrl.approval",
      "state": "propSimpleCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.managerOccupation),
      expression: "propostaSimplificada.managerOccupation"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "profissão do gerente",
      "id": "profissão do gerente",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.managerOccupation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "managerOccupation", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('profissão do gerente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('profissão do gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('uf gerente')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "uf gerente"
    }
  }, [_vm._v(" UF: ")]), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.managerUf),
      expression: "propostaSimplificada.managerUf"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "uf gerente",
      "id": "uf gerente"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.propostaSimplificada, "managerUf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.propostaSimplificada.managerUf,
      "selected": _vm.propostaSimplificada.managerUf
    }
  }, [_vm._v(_vm._s(_vm.propostaSimplificada.managerUf))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AC"
    }
  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AL"
    }
  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AM"
    }
  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AP"
    }
  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CE"
    }
  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DF"
    }
  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GO"
    }
  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MG"
    }
  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MS"
    }
  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MT"
    }
  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PA"
    }
  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PB"
    }
  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PE"
    }
  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PI"
    }
  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PR"
    }
  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RJ"
    }
  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RN"
    }
  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RO"
    }
  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RR"
    }
  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RS"
    }
  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SC"
    }
  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SP"
    }
  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TO"
    }
  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('uf gerente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('uf gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('cidade do gerente')
    },
    attrs: {
      "uib-tooltip": "Cidade do Gerente"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "cidade do gerente"
    }
  }, [_vm._v("Cidade:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.managerCity),
      expression: "propostaSimplificada.managerCity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cidade do gerente",
      "id": "cidade do gerente",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.managerCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "managerCity", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('cidade do gerente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cidade do gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('estado civil gerente')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "estado civil gerente"
    }
  }, [_vm._v("Estado Civil:")]), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.managerCivilStatus),
      expression: "propostaSimplificada.managerCivilStatus"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "estado civil gerente",
      "id": "estado civil gerente"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.propostaSimplificada, "managerCivilStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.propostaSimplificada.managerCivilStatus,
      "selected": _vm.propostaSimplificada.managerCivilStatus
    }
  }, [_vm._v(_vm._s(_vm.propostaSimplificada.managerCivilStatus))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SOLTEIRO"
    }
  }, [_vm._v("Solteiro(a)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CASADO"
    }
  }, [_vm._v("Casado(a)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DIVORCIADO"
    }
  }, [_vm._v("Divorciado(a)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIUVO"
    }
  }, [_vm._v("Viúvo(a)")])])]), _vm._v(" "), (_vm.errors.first('estado civil gerente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('estado civil gerente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('CPF gerente')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "managerCpf"
    }
  }, [_vm._v(" CPF: ")]), _vm._v(" "), _c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:11|cpf'),
      expression: "'required|max:11|cpf'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CPF gerente",
      "id": "CPF gerente",
      "mask": ['###.###.###-##']
    },
    model: {
      value: (_vm.propostaSimplificada.managerCpf),
      callback: function($$v) {
        _vm.$set(_vm.propostaSimplificada, "managerCpf", $$v)
      },
      expression: "propostaSimplificada.managerCpf"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('CPF gerente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CPF gerente')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('número rg')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "número rg"
    }
  }, [_vm._v(" Número do RG: ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.managerRg),
      expression: "propostaSimplificada.managerRg"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "número rg",
      "id": "número rg",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.managerRg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "managerRg", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('número rg')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('número rg')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('orgão emissor')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "orgão emissor"
    }
  }, [_vm._v(" Orgão Emissor: ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.managerRgIssuer),
      expression: "propostaSimplificada.managerRgIssuer"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "orgão emissor",
      "id": "orgão emissor",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.managerRgIssuer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "managerRgIssuer", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('orgão emissor')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('orgão emissor')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('uf RG')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "uf RG"
    }
  }, [_vm._v(" UF: ")]), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.managerRgUF),
      expression: "propostaSimplificada.managerRgUF"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "uf RG",
      "id": "uf RG"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.propostaSimplificada, "managerRgUF", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.propostaSimplificada.managerRgUF,
      "selected": _vm.propostaSimplificada.managerRgUF
    }
  }, [_vm._v(_vm._s(_vm.propostaSimplificada.managerRgUF))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AC"
    }
  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AL"
    }
  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AM"
    }
  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AP"
    }
  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CE"
    }
  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DF"
    }
  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GO"
    }
  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MG"
    }
  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MS"
    }
  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MT"
    }
  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PA"
    }
  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PB"
    }
  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PE"
    }
  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PI"
    }
  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PR"
    }
  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RJ"
    }
  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RN"
    }
  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RO"
    }
  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RR"
    }
  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RS"
    }
  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SC"
    }
  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SP"
    }
  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TO"
    }
  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('uf RG')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('uf RG')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Funcionário agência")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('matrícula do funcionário')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "matrícula do funcionário"
    }
  }, [_vm._v(" Matrícula do funcionário: ")]), _vm._v(" "), _c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|length:7'),
      expression: "'required|length:7'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "matrícula do funcionário",
      "placeholder": "Insira a matricula. Somente números e sem dígito.",
      "mask": '#######'
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.selectFuncionario(_vm.propostaSimplificada.employeeRegistration)
      }
    },
    model: {
      value: (_vm.propostaSimplificada.employeeRegistration),
      callback: function($$v) {
        _vm.$set(_vm.propostaSimplificada, "employeeRegistration", $$v)
      },
      expression: "propostaSimplificada.employeeRegistration"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('matrícula do funcionário')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('matrícula do funcionário')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('funcionário responsável')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "funcionário responsável"
    }
  }, [_vm._v(" Funcionário responsável pelo projeto: ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.employeeName),
      expression: "propostaSimplificada.employeeName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "funcionário responsável",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.employeeName)
    },
    on: {
      "keydown": function($event) {
        return _vm.selectFuncionario()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "employeeName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('funcionário responsável')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('funcionário responsável')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required col-md-12",
    class: {
      'has-error': _vm.errors.first('telefone do funcionário')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "telefone do funcionário"
    }
  }, [_vm._v(" Telefone fixo: ")]), _vm._v(" "), _c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "mask": ['(##) ####-####', '(##) #####-####'],
      "name": "telefone do funcionário",
      "type": "text"
    },
    model: {
      value: (_vm.propostaSimplificada.employeePhone),
      callback: function($$v) {
        _vm.$set(_vm.propostaSimplificada, "employeePhone", $$v)
      },
      expression: "propostaSimplificada.employeePhone"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('telefone do funcionário')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('telefone do funcionário')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required col-md-12",
    class: {
      'has-error': _vm.errors.first('e-mail funcionário')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "e-mail funcionário"
    }
  }, [_vm._v(" E-mail do funcionário: ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.employeeEmail),
      expression: "propostaSimplificada.employeeEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255|email'),
      expression: "'required|max:255|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "employeeEmail",
      "id": "e-mail funcionário",
      "type": "email"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.employeeEmail)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "employeeEmail", $event.target.value)
      }, function($event) {
        _vm.propostaSimplificada.employeeEmail = $event.target.value.toLowerCase()
      }]
    }
  })]), _vm._v(" "), (_vm.errors.first('e-mail funcionário')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('e-mail funcionário')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Informações")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('locais de execução do projeto')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "locais de execução do projeto"
    }
  }, [_vm._v(" Locais de execução do projeto: ")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.executePlaces),
      expression: "propostaSimplificada.executePlaces"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "locais de execução do projeto",
      "id": "locais de execução do projeto",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.executePlaces)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "executePlaces", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('locais de execução do projeto')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('locais de execução do projeto')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('objetivo geral')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "objetivo geral"
    }
  }, [_vm._v(" Objetivo Geral: ")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.generalObjective),
      expression: "propostaSimplificada.generalObjective"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "objetivo geral",
      "id": "objetivo geral",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.generalObjective)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "generalObjective", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('objetivo geral')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('objetivo geral')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('objetivo')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "infoObjectives"
    }
  }, [_vm._v(" Objetivo: ")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.infoObjectives),
      expression: "propostaSimplificada.infoObjectives"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "objetivo",
      "id": "objetivo",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.infoObjectives)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "infoObjectives", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('objetivo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('objetivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('resumo')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "resumo"
    }
  }, [_vm._v(" Resumo: ")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.summary),
      expression: "propostaSimplificada.summary"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "resumo",
      "id": "resumo",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.summary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "summary", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('resumo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('resumo')))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Número de Participantes")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required col-md-12",
    class: {
      'has-error': _vm.errors.first('participantes diretos')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "participantes diretos"
    }
  }, [_vm._v(" Participantes diretos: ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.participants),
      expression: "propostaSimplificada.participants"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1'),
      expression: "'required|min_value:1'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "participantes diretos",
      "id": "participantes diretos",
      "type": "number"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.participants)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "participants", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('participantes diretos')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('participantes diretos')))]) : _vm._e()])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_vm._m(7), _vm._v(" "), _c('publico-alvo', {
    attrs: {
      "propsPublicosGrid": _vm.propostaSimplificada.audiences
    },
    on: {
      "publicoAlvoAdicionado": function($event) {
        _vm.propostaSimplificada.audiences = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_vm._m(8), _vm._v(" "), _c('upload-documentos', {
    attrs: {
      "propDocumentos": _vm.propostaSimplificada.documents,
      "documentTypes": _vm.documentosProp,
      "documentosObrigatorios": _vm.documentosObrigatoriosProp
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_vm._m(9), _vm._v(" "), _c('upload-documentos', {
    attrs: {
      "propDocumentos": _vm.propostaSimplificada.documentStatements,
      "documentTypes": _vm.adimplencia,
      "documentosObrigatorios": _vm.adimplenciaObrig
    }
  })], 1)])])])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.conclui()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à lista")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Processo: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', [_c('a', {
    staticClass: "btn btn-flat active",
    attrs: {
      "id": "tabEntidade",
      "href": "#Entidade",
      "data-toggle": "tab"
    }
  }, [_vm._v(" Entidade ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn btn-flat",
    attrs: {
      "href": "#Proposta",
      "data-toggle": "tab"
    }
  }, [_vm._v(" Proposta ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro da Entidade: Simplificado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Endereço:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dirigentes:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos Upload")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro da Proposta Simplificada")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('br')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Público-alvo")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos Upload")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Declaração de Adimplência e Inexistência de Outras Fontes:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76631c4d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/entidade/EntidadeProposta.vue
// module id = 2018
// module chunks = 1